import { Location } from '@angular/common';
import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class BackNavigationService implements OnDestroy {
    origin = window.location.origin;
    private hasNavigated = false;
    private routerSub: Subscription;

    constructor(
        private translate: TranslateService,
        private location: Location,
        private router: Router
    ) {
        this.routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.hasNavigated = true;
            }
        });
    }

    goBack(navigateTo = this.origin): void {
        if (this.hasNavigated) {
            this.location.back();
        } else {
            this.router.navigate([this.translate.currentLang, navigateTo]);
        }
    }

    ngOnDestroy() {
        if (this.routerSub) {
            this.routerSub.unsubscribe();
        }
    }
}
